import * as React from "react"
import IndividualContactFormBody from "../IndividualContactFormBody";
import ContactForm from "../dto/ContactForm";
import IndividualContactData from "../../../../model/contact/individual/IndividualContactData";
import BaseFormView, {BaseFormViewState, EditFormViewProps} from "../../../ui/form/BaseFormView";
import IndividualContact from "../../../../model/contact/IndividualContact";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../navigation/route/Route";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import {getLoggedUser} from "../../../../store/view/user";

interface ComponentProps {
	/**
	 * On submit callback.
	 */
	onSubmit: (contact: IndividualContactData, updateArchivedStatus: boolean) => void;
	/**
	 * On cancel callback
	 */
	onCancel?: () => void;
}


type State = BaseFormViewState<ContactForm>;

type Props =
	ComponentProps
	& EditFormViewProps<IndividualContact>
	& RouteComponentProps<ComponentProps & EditFormViewProps<IndividualContact>>;

/**
 * Edit individual contact form view.
 */
class EditIndividualContactFormView extends BaseFormView<ContactForm, Props, State> {
	/**
	 * Indicates if "archived" checkbox is enabled.
	 */
	userCanArchiveContact: boolean;

	constructor(props: Props) {
		super(props);
		this.state = {
			form: ContactForm.createFromContact(props.model),
			shouldValidate: false,
			isFormDirty: false
		};
		this.userCanArchiveContact = getLoggedUser().map(u => u.hasContactArchivePerm()).getOrElse(false);
		this.submitForm = this.submitForm.bind(this);
	}

	render() {
		return (
			<div>
				<IndividualContactFormBody form={this.state.form}
										   onFieldChange={this.onFieldChanged}
										   onFieldCompleted={() => {}}
										   onFocusChange={() => {}}
										   onFieldsChange={this.onFieldsChanged}
										   archiveCheckboxEnabled={this.userCanArchiveContact}
										   editMode={true}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary label={"Cancel"}
									onClick={() => this.props.onCancel ? this.props.onCancel() :
										this.props.history.replace(Routes.ContactsList)}/>
					<ButtonPrimary label={"Save contact"} onClick={this.submitForm} isLoading={this.props.isLoading}/>
				</FormButtonsView>
			</div>
		);
	}

	/**
	 * Callback onSubmit button click.
	 */
	submitForm() {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onIndividualValid(
				this.props.model.data.primarySiteId,
				(contactData: IndividualContactData) => {
					this.props.onSubmit(contactData, this.userCanArchiveContact);
				},
				() => {}
			);
		});
	}
}

export default withRouter<ComponentProps & EditFormViewProps<IndividualContact>>(EditIndividualContactFormView)